"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SelectInputField = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _formik = require("formik");
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("../../constants/theme");
var _useThemeContext = require("../../hooks/useThemeContext");
var _Toggle = _interopRequireDefault(require("../figure/Toggle"));
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _excluded = ["ToggleComponent"],
  _excluded2 = ["children", "hideChoices"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["id", "hideChoices", "error", "variant", "position", "ToggleComponent", "filterFromStart", "thinShadow", "rounded", "dataCy", "styles", "isSearchable", "onChange", "color"],
  _excluded6 = ["name", "validate"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// HACK: real typings do not contain isDisabled despite it existing, so we use our own type.

var _DropdownIndicator = function DropdownIndicator(baseProps) {
  var theme = (0, _useThemeContext.useThemeContext)();
  var ToggleComponent = baseProps.ToggleComponent,
    props = (0, _objectWithoutProperties2["default"])(baseProps, _excluded);
  return _reactSelect.components.DropdownIndicator && /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react["default"].createElement(ToggleComponent, {
    style: {
      color: props.isDisabled ? theme.colors.neutral['30'] : props.isFocused ? theme.colors.primary['40'] : theme.colors.primary['100'],
      maxWidth: '1.6rem'
    }
  }));
};
var IndicatorsContainer = function IndicatorsContainer(_ref) {
  var children = _ref.children,
    hideChoices = _ref.hideChoices,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.IndicatorsContainer, props, !hideChoices && /*#__PURE__*/_react["default"].createElement(ChoicesCount, null, props.options.length, " keuzes"), children);
};
var CustomSingleValue = function CustomSingleValue(_ref2) {
  var children = _ref2.children,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.SingleValue, props, props.data.icon && /*#__PURE__*/_react["default"].createElement(SvgContainer, null, props.data.icon), children);
};
var CustomOption = function CustomOption(_ref3) {
  var children = _ref3.children,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded4);
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, props, /*#__PURE__*/_react["default"].createElement(OptionWrap, {
    isDisabled: props.isDisabled
  }, props.data.icon && /*#__PURE__*/_react["default"].createElement(SvgContainer, null, props.data.icon), children));
};
var getShadow = function getShadow(color, thin) {
  return "0 0 0 1px ".concat(color, ", inset 0 0 0 ").concat(thin ? 0 : '1px', " ").concat(color);
};
var SelectInputField = exports.SelectInputField = function SelectInputField(_ref4) {
  var id = _ref4.id,
    _ref4$hideChoices = _ref4.hideChoices,
    hideChoices = _ref4$hideChoices === void 0 ? false : _ref4$hideChoices,
    error = _ref4.error,
    _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? 'medium' : _ref4$variant,
    _ref4$position = _ref4.position,
    position = _ref4$position === void 0 ? 'absolute' : _ref4$position,
    _ref4$ToggleComponent = _ref4.ToggleComponent,
    ToggleComponent = _ref4$ToggleComponent === void 0 ? _Toggle["default"] : _ref4$ToggleComponent,
    _ref4$filterFromStart = _ref4.filterFromStart,
    filterFromStart = _ref4$filterFromStart === void 0 ? false : _ref4$filterFromStart,
    _ref4$thinShadow = _ref4.thinShadow,
    thinShadow = _ref4$thinShadow === void 0 ? false : _ref4$thinShadow,
    _ref4$rounded = _ref4.rounded,
    rounded = _ref4$rounded === void 0 ? false : _ref4$rounded,
    dataCy = _ref4.dataCy,
    propStyles = _ref4.styles,
    _ref4$isSearchable = _ref4.isSearchable,
    isSearchable = _ref4$isSearchable === void 0 ? false : _ref4$isSearchable,
    onChange = _ref4.onChange,
    _ref4$color = _ref4.color,
    color = _ref4$color === void 0 ? 'neutral' : _ref4$color,
    props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded5);
  var theme = (0, _useThemeContext.useThemeContext)();
  var filterConfig = (0, _reactSelect.createFilter)({
    matchFrom: filterFromStart ? 'start' : 'any'
  });
  return /*#__PURE__*/_react["default"].createElement(Container, {
    "data-cy": dataCy
  }, /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], Object.assign({
    onChange: onChange,
    inputId: id,
    isSearchable: isSearchable,
    styles: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, propStyles), {}, {
      placeholder: function placeholder(placeHolderProps) {
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, placeHolderProps), {}, {
          color: theme.colors.neutral['40']
        });
      },
      indicatorSeparator: function indicatorSeparator() {
        return {
          display: 'none'
        };
      },
      singleValue: function singleValue(styles, state) {
        var _propStyles$singleVal;
        var newStyles = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, styles), {}, {
          color: state.isDisabled ? '#545454' : 'inherit',
          display: 'flex'
        });
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, newStyles), propStyles === null || propStyles === void 0 ? void 0 : (_propStyles$singleVal = propStyles.singleValue) === null || _propStyles$singleVal === void 0 ? void 0 : _propStyles$singleVal.call(propStyles, newStyles, state));
      },
      control: function control(styles, state) {
        var _propStyles$control;
        var newStyles = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, styles), {}, {
          height: variant === 'small' ? '3.6rem' : '4.8rem',
          // TODO: Add media query again for the small variant for the partner app. For now not needed for voorkant.
          // [mediaQuery]: { height: '3.6rem' },
          borderRadius: rounded ? '2.4rem' : '0.5rem',
          borderWidth: '2px',
          backgroundColor: state.isDisabled ? theme.colors.neutral['10'] : theme.colors.neutral['0'],
          border: 'none',
          boxShadow: error ? getShadow(theme.colors.negative['60'], thinShadow) : state.isFocused ? getShadow((0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input), thinShadow) : getShadow(theme.colors.neutral['20'], thinShadow),
          padding: '0 0.7rem',
          paddingRight: '1.5rem',
          '&:hover': {
            boxShadow: state.isFocused ? getShadow((0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input), thinShadow) : getShadow(theme.colors.neutral['30'], thinShadow)
          }
        });
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, newStyles), propStyles === null || propStyles === void 0 ? void 0 : (_propStyles$control = propStyles.control) === null || _propStyles$control === void 0 ? void 0 : _propStyles$control.call(propStyles, newStyles, state));
      },
      menu: function menu(styles) {
        var _props$styles;
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, styles), {}, {
          zIndex: theme.zIndices.dropdown,
          position: position,
          boxShadow: '0 0 40px 0 rgba(16, 36, 48, 0.1)',
          borderRadius: '0.5rem',
          overflow: 'hidden'
        }, (_props$styles = props.styles) === null || _props$styles === void 0 ? void 0 : _props$styles.menu);
      },
      container: function container(styles, _ref5) {
        var _props$styles2;
        var isDisabled = _ref5.isDisabled;
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, styles), {}, {
          cursor: isDisabled ? 'not-allowed' : 'inherit'
        }, (_props$styles2 = props.styles) === null || _props$styles2 === void 0 ? void 0 : _props$styles2.container);
      },
      option: function option(styles, _ref6) {
        var _props$styles3;
        var isSelected = _ref6.isSelected,
          isFocused = _ref6.isFocused;
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, styles), {}, {
          display: 'flex',
          alignItems: 'center',
          color: color === 'primary' && isSelected ? theme.colors.neutral[0] : theme.colors.neutral['100'],
          backgroundColor: function () {
            switch (color) {
              default:
              case 'neutral':
                return isSelected ? theme.colors.neutral['20'] : isFocused ? theme.colors.neutral['10'] : styles.backgroundColor;
              case 'primary':
                return isSelected ? theme.colors.primary['70'] : isFocused ? theme.colors.primary['10'] : styles.backgroundColor;
            }
          }(),
          '&:hover': {
            backgroundColor: function backgroundColor() {
              switch (color) {
                default:
                case 'neutral':
                  return !isSelected ? theme.colors.neutral['10'] : theme.colors.neutral['20'];
                case 'primary':
                  return !isSelected ? theme.colors.primary['10'] : theme.colors.primary['20'];
              }
            }
          }
        }, (_props$styles3 = props.styles) === null || _props$styles3 === void 0 ? void 0 : _props$styles3.option);
      }
    }),
    isDisabled: props.disabled,
    components: {
      SingleValue: CustomSingleValue,
      Option: CustomOption,
      DropdownIndicator: function DropdownIndicator(rest) {
        return /*#__PURE__*/_react["default"].createElement(_DropdownIndicator, Object.assign({
          ToggleComponent: ToggleComponent
        }, rest));
      },
      IndicatorSeparator: function IndicatorSeparator(rest) {
        return /*#__PURE__*/_react["default"].createElement(IndicatorsContainer, Object.assign({
          hideChoices: hideChoices
        }, rest));
      }
    },
    filterOption: filterConfig
  }, props)), error && /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], null, error));
};
var SelectInput = function SelectInput(_ref7) {
  var name = _ref7.name,
    validate = _ref7.validate,
    props = (0, _objectWithoutProperties2["default"])(_ref7, _excluded6);
  var _useField = (0, _formik.useField)({
      name: name,
      validate: validate
    }),
    _useField2 = (0, _slicedToArray2["default"])(_useField, 3),
    field = _useField2[0],
    _useField2$ = _useField2[1],
    error = _useField2$.error,
    touched = _useField2$.touched,
    helpers = _useField2[2];
  return /*#__PURE__*/_react["default"].createElement(SelectInputField, Object.assign({
    name: name,
    onChange: function onChange(selectedOption) {
      // mirror mirror on the wall, which has the shittiest typings of them all...
      helpers.setValue(selectedOption.value);
    },
    onBlur: function onBlur() {
      setTimeout(function () {
        return helpers.setTouched(true);
      });
    },
    error: touched && error ? error : undefined,
    value: props.options && props.options.find(function (option) {
      return option.value === field.value;
    }) || null
  }, props));
};
var _default = exports["default"] = SelectInput;
var Container = _styledComponents["default"].div.withConfig({
  displayName: "SelectInput__Container",
  componentId: "sc-10n6hnx-0"
})([""]);
var ChoicesCount = _styledComponents["default"].span.withConfig({
  displayName: "SelectInput__ChoicesCount",
  componentId: "sc-10n6hnx-1"
})(["font-size:12px;color:", ";letter-spacing:0;line-height:20px;margin:0.4rem;@media (max-width:", "){display:none;}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.neutral['30'];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.mediaQueries.m;
});
var OptionWrap = _styledComponents["default"].div.withConfig({
  displayName: "SelectInput__OptionWrap",
  componentId: "sc-10n6hnx-2"
})(["display:flex;justify-content:center;opacity:", ";"], function (_ref10) {
  var isDisabled = _ref10.isDisabled;
  return isDisabled ? 0.4 : 1;
});
var SvgContainer = _styledComponents["default"].span.attrs({
  className: 'input-select__icon'
}).withConfig({
  displayName: "SelectInput__SvgContainer",
  componentId: "sc-10n6hnx-3"
})(["display:flex;align-items:center;margin:0 1rem 0 0.3rem;> svg{flex-shrink:0;}width:3rem !important;"]);
//# sourceMappingURL=SelectInput.js.map